import { render, staticRenderFns } from "./PwaApprContent.vue?vue&type=template&id=5d857f49&"
import script from "./PwaApprContent.vue?vue&type=script&lang=js&"
export * from "./PwaApprContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports